// import React, { useEffect, useState } from "react";
// import {
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   Paper,
//   TextField,
//   Autocomplete,
//   Typography,
//   CircularProgress,
// } from "@mui/material";
// import { CheckCircle, Cancel, Medication } from "@mui/icons-material";
// import { getDecryptedAccessToken } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
// import ApiServices from "../../../Utils/ApiServices/ApiServices";

// const AllDrugs = ({onDrugClick}) => {
//   const accessToken = getDecryptedAccessToken();

//   const [drugs, setDrugs] = useState([]);
//   const [filteredDrugs, setFilteredDrugs] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");

//   const [searchTerm, setSearchTerm] = useState("");
//   const [selectedForm, setSelectedForm] = useState(null);
//   const [selectedRoute, setSelectedRoute] = useState(null);

//   useEffect(() => {
//     ApiServices.get("/apis/default/api/drug", {
//       Authorization: `Bearer ${accessToken}`,
//     })
//       .then((response) => {
//         if (response.data?.data) {
//           setDrugs(response.data.data);
//           setFilteredDrugs(response.data.data);
//           setLoading(false);
//         } else {
//           throw new Error("No data available");
//         }
//       })
//       .catch((error) => {
//         console.error("Error fetching drugs:", error);
//         setError("Failed to fetch data");
//         setLoading(false);
//       });
//   }, []);

//   // Extract unique values for form & route for dropdowns
//   const formOptions = [...new Set(drugs.map((drug) => drug.form).filter(Boolean))];
//   const routeOptions = [...new Set(drugs.map((drug) => drug.route).filter(Boolean))];

//   // Filter logic
//   useEffect(() => {
//     let filtered = drugs;

//     if (searchTerm) {
//       filtered = filtered.filter((drug) =>
//         drug.name.toLowerCase().includes(searchTerm.toLowerCase())
//       );
//     }
//     if (selectedForm) {
//       filtered = filtered.filter((drug) => drug.form === selectedForm);
//     }
//     if (selectedRoute) {
//       filtered = filtered.filter((drug) => drug.route === selectedRoute);
//     }

//     setFilteredDrugs(filtered);
//   }, [searchTerm, selectedForm, selectedRoute, drugs]);

//   return (
//     <div style={{ padding: "20px" }}>
     
//       {/* Search & Filters */}
//       <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
//         <TextField
//           label="Search by Name"
//           variant="outlined"
//           fullWidth
//           value={searchTerm}
//           onChange={(e) => setSearchTerm(e.target.value)}
//         />
//         <Autocomplete
//           options={formOptions}
//           getOptionLabel={(option) => option}
//           value={selectedForm}
//           onChange={(event, newValue) => setSelectedForm(newValue)}
//           renderInput={(params) => <TextField {...params} label="Filter by Form" />}
//           fullWidth
//         />
//         <Autocomplete
//           options={routeOptions}
//           getOptionLabel={(option) => option}
//           value={selectedRoute}
//           onChange={(event, newValue) => setSelectedRoute(newValue)}
//           renderInput={(params) => <TextField {...params} label="Filter by Route" />}
//           fullWidth
//         />
//       </div>

//       {/* Loading State */}
//       {loading && (
//         <div style={{ textAlign: "center", marginTop: "20px" }}>
//           <CircularProgress />
//           <Typography>Loading drugs...</Typography>
//         </div>
//       )}

//       {/* Error State */}
//       {error && (
//         <Typography color="error" align="center">
//           {error}
//         </Typography>
//       )}

//       {/* No Data State */}
//       {!loading && !error && filteredDrugs.length === 0 && (
//         <Typography align="center">No drugs available</Typography>
//       )}

//       {/* Drug Table */}
//       {!loading && filteredDrugs.length > 0 && (
//         <TableContainer component={Paper}>
//           <Table>
//             <TableHead>
//               <TableRow>
//                 <TableCell>Name</TableCell>
//                 <TableCell>NDC Number</TableCell>
//                 <TableCell>Form</TableCell>
//                 <TableCell>Size</TableCell>
//                 <TableCell>Unit</TableCell>
//                 <TableCell>Route</TableCell>
//                 <TableCell>Related Code</TableCell>
//                 <TableCell>Active</TableCell>
//               </TableRow>
//             </TableHead>
//             <TableBody>
//               {filteredDrugs.map((drug) => (
//                 <TableRow key={drug.drug_id} >
//                   <TableCell onClick={() => onDrugClick(drug)}>
//                     <Medication style={{ color: "#1976d2", marginRight: 5 }} />
//                     {drug.name}
//                   </TableCell>
//                   <TableCell>{drug.ndc_number || "N/A"}</TableCell>
//                   <TableCell>{drug.form || "N/A"}</TableCell>
//                   <TableCell>{drug.size || "N/A"}</TableCell>
//                   <TableCell>{drug.unit || "N/A"}</TableCell>
//                   <TableCell>{drug.route || "N/A"}</TableCell>
//                   <TableCell>{drug.related_code || "N/A"}</TableCell>
//                   <TableCell>
//                     {drug.active === "1" ? (
//                       <CheckCircle style={{ color: "green" }} />
//                     ) : (
//                       <Cancel style={{ color: "red" }} />
//                     )}
//                   </TableCell>
//                 </TableRow>
//               ))}
//             </TableBody>
//           </Table>
//         </TableContainer>
//       )}
//     </div>
//   );
// };

// export default AllDrugs;


import React, { useEffect, useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TextField,
  Autocomplete,
  Typography,
  CircularProgress,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Snackbar,
  Alert,
  Chip,
} from "@mui/material";
import { CheckCircle, Cancel, Medication, Delete } from "@mui/icons-material";
import { getDecryptedAccessToken, getDecryptedData } from "../../../Utils/LoginUserDetails.js/LoginUserSavedDetails";
import ApiServices from "../../../Utils/ApiServices/ApiServices";

const AllDrugs = ({ onDrugClick }) => {
  const accessToken = getDecryptedAccessToken();

  const [drugs, setDrugs] = useState([]);
  const [filteredDrugs, setFilteredDrugs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
const LoginUserDetails = getDecryptedData()
  const [searchTerm, setSearchTerm] = useState("");
  const [selectedForm, setSelectedForm] = useState(null);
  const [selectedRoute, setSelectedRoute] = useState(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [selectedDrug, setSelectedDrug] = useState(null);
  const [deleting, setDeleting] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "info" });

  useEffect(() => {
    fetchDrugs();
  }, []);

  const fetchDrugs = () => {
    setLoading(true);
    ApiServices.get("/apis/default/api/drug", {
      Authorization: `Bearer ${accessToken}`,
    })
      .then((response) => {
        if (response.data?.data) {
          setDrugs(response.data.data);
          setFilteredDrugs(response.data.data);
          setLoading(false);
        } else {
          throw new Error("No data available");
        }
      })
      .catch((error) => {
        console.error("Error fetching drugs:", error);
        setError("Failed to fetch data");
        setLoading(false);
      });
  };

  // Extract unique values for form & route for dropdowns
  const formOptions = [...new Set(drugs.map((drug) => drug.form).filter(Boolean))];
  const routeOptions = [...new Set(drugs.map((drug) => drug.route).filter(Boolean))];

  // Filter logic
  useEffect(() => {
    let filtered = drugs;

    if (searchTerm) {
      filtered = filtered.filter((drug) =>
        drug.name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }
    if (selectedForm) {
      filtered = filtered.filter((drug) => drug.form === selectedForm);
    }
    if (selectedRoute) {
      filtered = filtered.filter((drug) => drug.route === selectedRoute);
    }

    setFilteredDrugs(filtered);
  }, [searchTerm, selectedForm, selectedRoute, drugs]);

  // Handle Delete Click
  const handleDeleteClick = (drug) => {
    setSelectedDrug(drug);
    setDeleteDialogOpen(true);
  };

  // Handle Delete Confirmation
  const handleDeleteConfirm = () => {
    if (!selectedDrug) return;

    setDeleting(true);

    ApiServices.deleteWithPayload(`/apis/default/api/drug/${selectedDrug.uuid}`,{
        deleted_by : LoginUserDetails.id
    }, {
      Authorization: `Bearer ${accessToken}`,
    })
      .then(() => {
        setSnackbar({ open: true, message: "Drug deleted successfully!", severity: "success" });
        fetchDrugs(); // Refresh the list after deletion
      })
      .catch((error) => {
        console.error("Error deleting drug:", error);
        setSnackbar({ open: true, message: "Failed to delete drug!", severity: "error" });
      })
      .finally(() => {
        setDeleting(false);
        setDeleteDialogOpen(false);
      });
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Search & Filters */}
      <div style={{ display: "flex", gap: "15px", marginBottom: "15px" }}>
        <TextField
          label="Search by Name"
          variant="outlined"
          fullWidth
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <Autocomplete
          options={formOptions}
          getOptionLabel={(option) => option}
          value={selectedForm}
          onChange={(event, newValue) => setSelectedForm(newValue)}
          renderInput={(params) => <TextField {...params} label="Filter by Form" />}
          fullWidth
        />
        <Autocomplete
          options={routeOptions}
          getOptionLabel={(option) => option}
          value={selectedRoute}
          onChange={(event, newValue) => setSelectedRoute(newValue)}
          renderInput={(params) => <TextField {...params} label="Filter by Route" />}
          fullWidth
        />
      </div>

      {/* Loading State */}
      {loading && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <CircularProgress />
          <Typography>Loading drugs...</Typography>
        </div>
      )}

      {/* Error State */}
      {error && (
        <Typography color="error" align="center">
          {error}
        </Typography>
      )}

      {/* No Data State */}
      {!loading && !error && filteredDrugs.length === 0 && (
        <Typography align="center">No drugs available</Typography>
      )}

      {/* Drug Table */}
      {!loading && filteredDrugs.length > 0 && (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>NDC Number</TableCell>
                <TableCell>Form</TableCell>
                <TableCell>Size</TableCell>
                <TableCell>Unit</TableCell>
                <TableCell>Route</TableCell>
                <TableCell>Related Code</TableCell>
                <TableCell>Active</TableCell>
                <TableCell>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredDrugs.map((drug) => (
                <TableRow key={drug.drug_id}>
                  <TableCell onClick={(e) => e.stopPropagation() || onDrugClick(drug)}>
                    <Medication style={{ color: "#1976d2", marginRight: 5 }} />
                    {drug.name}
                  </TableCell>
                  <TableCell>{drug.ndc_number || "N/A"}</TableCell>
                  <TableCell>{drug.form || "N/A"}</TableCell>
                  <TableCell>{drug.size || "N/A"}</TableCell>
                  <TableCell>{drug.unit || "N/A"}</TableCell>
                  <TableCell>{drug.route || "N/A"}</TableCell>
                  <TableCell>{drug.related_code || "N/A"}</TableCell>
                  <TableCell>
                    {drug.active === "1" ? (
                      <CheckCircle style={{ color: "green" }} />
                    ) : (
                      <Cancel style={{ color: "red" }} />
                    )}
                  </TableCell>
                  <TableCell>
                    <Chip
                      icon={<Delete />}
                      label="Delete"
                      onClick={() => handleDeleteClick(drug)}
                      color="error"
                      clickable
                    />
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Deletion</DialogTitle>
        <DialogContent>
          Are you sure you want to delete <b>{selectedDrug?.name}</b>?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={deleting}>Cancel</Button>
          <Button onClick={handleDeleteConfirm} color="error" disabled={deleting}>
            {deleting ? "Deleting..." : "Confirm"}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Snackbar for Notifications */}
      <Snackbar open={snackbar.open} autoHideDuration={3000} onClose={() => setSnackbar({ ...snackbar, open: false })}>
        <Alert severity={snackbar.severity}>{snackbar.message}</Alert>
      </Snackbar>
    </div>
  );
};

export default AllDrugs;
